export const GET_SOCIAL_NOTIFICATIONS = "getSocialNotifications";
export const IS_LOADING = "isLoading";
export const GET_SELECTED_FOR_INTERACTION = "getSelectedForInteraction";
